import { render } from "./WalkthroughIndicator.vue?vue&type=template&id=2f15c41c&scoped=true&ts=true"
import script from "./WalkthroughIndicator.vue?vue&type=script&lang=ts"
export * from "./WalkthroughIndicator.vue?vue&type=script&lang=ts"

import "./WalkthroughIndicator.scss?vue&type=style&index=0&id=2f15c41c&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f15c41c"]])

export default __exports__